import type { App } from 'vue';
import {
  createRouter as _createRouter,
  createWebHashHistory,
  type RouteRecordRaw,
} from 'vue-router';

const createRouter = (app: App, routes: RouteRecordRaw[]) => {
  const router = _createRouter({
    history: createWebHashHistory(),
    routes,
  });
  app.use(router);
  return router;
};

export default createRouter;
